import { Link, useSearchParams } from "react-router-dom";
import MuiLink from "@mui/material/Link";
import type { SxProps, TypographyProps } from "@mui/material";

export interface CrudLinkProps {
  children?: React.ReactNode;
  path?: string;
  tab: string;
  id: string;
  component?: React.ElementType;
  target?: string;
  color?: string;
  variant?: TypographyProps["variant"];
  noWrap?: boolean;
  sx?: SxProps;
  underline?: "none" | "hover" | "always";
}

export function CrudLink({
  children,
  path = "",
  tab,
  id,
  component = MuiLink,
  target,
  color = "secondary",
  underline = "hover",
  variant,
  noWrap,
  sx,

  ...props
}: CrudLinkProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const to = `${path}?tab=${tab}&id=${id}`;

  const onClick = (event: React.MouseEvent) => {
    /**
     * Если передан определенный путь то пусть роутер работает
     */
    if (path) {
      return;
    }

    event.preventDefault();

    if (tab) {
      searchParams.set("tab", tab);
    }

    if (id) {
      searchParams.set("id", id);
    }

    setSearchParams(searchParams);
  };

  const Component = component;

  return (
    <Component
      component={Link}
      target={target}
      to={to}
      onClick={onClick}
      color={color}
      underline={underline}
      variant={variant}
      noWrap={noWrap}
      sx={sx}
      {...props}
    >
      {children}
    </Component>
  );
}
